// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"253":"844f564c","383":"37139e4d","966":"88d92fd2"}[chunkId] + ".css";
};